import { useEffect, useState } from "react"
import { useSearchParams } from 'react-router-dom';
import axios from "axios";
import "./AddVendorContactDetails.css"


function AddVendorContactDetails({setShowDetailForms,userType,formSubmitted}){
    const[searchParm]=useSearchParams ();
    const baseAPI = process.env.REACT_APP_API_URL;
    const[DataFilled,setDataFilled]=useState(false);
    const[filledData,setFilledData]=useState(null)
    const [isEmailValid, setIsEmailValid] = useState(false);
    const[showInputFields,setShowInptFields]=useState(false)
    const[edit,setEdit]=useState(false)
    const [ContactDetailForm, setContactDetailForm] = useState({
        Salutation: "",
        FirstName: "",
        LastName: "",
        Email: "",
        WorkPhone: "",
        Mobile: "",
        CreatedBy:userType,
        ModifiedBy:"null",

      });

      useEffect(() => {
        if(searchParm.get("vendorID")!=null){
          checkDataFilled(searchParm.get("vendorID"))
        setContactDetailForm({
          ...ContactDetailForm,
              VendorGUID:searchParm.get("vendorID")
            });
        }
    
      }, []);

      function checkDataFilled(id){
        const storedToken = JSON.parse(localStorage.getItem("token")
      );
        
          axios
          .get(`${baseAPI}admin/GETVendorContactGUID?VendorID=${id}`, {
            })
            .then((response) => {
                            if(response.data.data[0].VendorGUID!=null){
                              setFilledData(response.data.data)
                              setContactDetailForm(response.data.data[0])
              }
            })
            .catch((error) => {
              console.error("Error fetching user detail:", error);
            })
      };
    

    function handleChange(e){
      const{name,value}=e.target
      // if (name === "Email") {
      //   const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      //   setIsEmailValid(isValidEmail);
      // }
    
setContactDetailForm({
  ...ContactDetailForm,
  [name]:value
})
    }

    function showClickedForm(){
      const newObj = {
        AddressForm: false,
        OtherDetailsForm: false,
        BankDetailsForm: false,
        ContactDetailsForm: false,
        TermsForm: false
      }
  
      newObj.TermsForm = true;
      setShowDetailForms(newObj)
    }

    // console.log(ContactDetailForm)

    function checkMailValidation(email){
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
     if(isValidEmail){
      return true
     }
     else{
      return false
     }
    }

    const validatePhoneNumber = (phoneNumber) => {
      const personalPhoneRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
      const workPhoneRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})(?: *x(\d+))?$/;
    
      return personalPhoneRegex.test(phoneNumber) || workPhoneRegex.test(phoneNumber);
    };

    const handleSubmit = async (e) => {
      let updatedForm={}
      if(ContactDetailForm.ContactID!==0){
       updatedForm = {
        ...ContactDetailForm,
      CreatedBy: userType
    }
  }
    else {
      updatedForm={
        ...ContactDetailForm,
        ContactID:0
      }
    
    
  }
  for (const key in ContactDetailForm) {
    if (key === "WorkPhone") {
      continue;
    } else {
      if (ContactDetailForm[key] === "") {
        alert("All fields are mandatory. Please fill out all fields.");
        return;
      }
    }
  } 
   const isEmailValid=   checkMailValidation(ContactDetailForm.Email)
  if(!isEmailValid){
    alert("Email Is Not Valid")
    return;
  }
  if(ContactDetailForm.WorkPhone!==""){
  if (!validatePhoneNumber(ContactDetailForm.WorkPhone)) {
    alert("Please enter a valid phone number.");
    return;
  }
}
  if (!validatePhoneNumber(ContactDetailForm.Mobile)) {
    alert("Please enter a valid phone number.");
    return;
  }
      e.preventDefault();
      showClickedForm()
          try {
            const response = await axios.post(
                `${baseAPI}Admin/AddVendorContactDetail`,
               updatedForm,
                {
                }
            );
            checkDataFilled(searchParm.get("vendorID"))
            setContactDetailForm({
            Salutation: "",
            FirstName: "",
            LastName: "",
            Email: "",
            WorkPhone: "",
            Mobile: ""
                      })
        } catch (error) {
            console.error("Error posting data:", error);
        }
    };

    function AddMoreAccounts() {
      setShowInptFields(true)
      setContactDetailForm({
        VendorGUID:searchParm.get("vendorID"),
        CreatedBy:"Vendor",
        Salutation: "",
        FirstName: "",
        LastName: "",
        Email: "",
        WorkPhone: "",
        Mobile: ""  
      })
  }

  function ResetForm(){
    setContactDetailForm({
      Salutation: "",
      FirstName: "",
      LastName: "",
      Email: "",
      WorkPhone: "",
      Mobile: "",
      VendorGUID:searchParm.get("vendorID")
    })
  }

  function updateCurrentVendorContactDetail(data){
    setContactDetailForm(data)
    setEdit(true)
    setShowInptFields(true)
      }

      function cancelEdit(){
        setShowInptFields(false)
      }
    

      return(
        <div className="container-fluid"
         style={{paddingBottom:"30px"}}
         >
         
          
           <div className="">
            {filledData===null?
             <div  className={`vndor_contact_details_main_div ${userType === "admin" ? "admin_type_contact__main-div" : ""}`}>
  
             <table style={{ width: "100%"}}>
             <tbody className="row"  >
    <div className="col-lg-6 col-md-6 col-sm-6">
  <tr><td>Salutation</td>
  <select              className="form-control"  
              name="Salutation"
              onChange={handleChange}
              required
              value={ContactDetailForm.Salutation}
            >
              <option value="0">Select an option</option>
              <option value="Miss">Miss</option>
              <option value="Mr.">Mr.</option>
              <option value="Mrs.">Mrs.</option>
         </select> 
  </tr>
  
  <tr>   
  <td>Last Name</td>
  <input
    type="text"
    name="LastName"
   
    value={ContactDetailForm.LastName}
    placeholder="Please Enter*"
    onChange={handleChange}
    required
  />
  </tr>
  <tr>   
  <td>Work Phone</td>
  <input
    type="tel"
    name="WorkPhone"
   
    value={ContactDetailForm.WorkPhone}
    placeholder="Please Enter*"
    onChange={handleChange}
    required
  />
  </tr>
  </div>
  <div className="col-lg-6 col-md-6 col-sm-6">
  <tr><td>First Name</td>
  <input
    type="text"
    name="FirstName"
   
    value={ContactDetailForm.FirstName}
    placeholder="Please Enter*"
            onChange={handleChange}  
            required
  />
  </tr>
  <tr>   
  <td>Email Address</td>
  <input
    type="email"
    name="Email"
   
    value={ContactDetailForm.Email}
    placeholder="Please Enter*"
    onChange={handleChange}
    required
  />
  </tr>
  
  <tr>   
  <td >Mobile</td>
  <input
    type="text"
    name="Mobile"
   
    value={ContactDetailForm.Mobile}
    placeholder="Please Enter*"
    onChange={handleChange}
    required
  />
  </tr>
  </div>
  
  </tbody>
           </table>
           
               <br />
               <hr />
               <div style={{marginBottom:"38px",display:"flex"}}  className={`reset-addSupplier-button ${userType === "admin" ? "admin_type_contact_buttons_main_div" : ""}`}>
             {edit?
              <button
                type="submit"
                onClick={handleSubmit}
                style={{
                  backgroundColor: "#5B489D",
                  color: "white",
                }}
              >
                Update
              </button>
           :
           formSubmitted?
           null:
           <button
             type="submit"
             onClick={handleSubmit}
             style={{
               backgroundColor: "#5B489D",
               color: "white",
             }}
           >
             Next
           </button>
           }
           {formSubmitted?
           null
           :
            <button
            onClick={cancelEdit}
              style={{
                color: "red",
                backgroundColor:"white",
                 border:"none"
              }}
            >
              Cancel
            </button> 
           }
           
           
               </div>
             </div>
            :
            showInputFields?
            <div>
                <div  className={`vndor_contact_details_main_div ${userType === "admin" ? "admin_type_contact__main-div" : ""}`}>
  
  <table style={{ width: "100%"}}>
  <tbody className="row"  >
    <div className="col-lg-6 col-md-6 col-sm-6">
  <tr><td>Salutation</td>
  <select              className="form-control"  
              name="Salutation"
              onChange={handleChange}
              required
              value={ContactDetailForm.Salutation}
            >
              <option value="0">Select an option</option>
              <option value="Miss">Miss</option>
              <option value="Mr.">Mr.</option>
              <option value="Mrs.">Mrs.</option>
         </select> 
  </tr>
  
  <tr>   
  <td>Last Name</td>
  <input
    type="text"
    name="LastName"
   
    value={ContactDetailForm.LastName}
    placeholder="Please Enter*"
    onChange={handleChange}
    required
  />
  </tr>
  <tr>   
  <td>Work Phone</td>
  <input
    type="tel"
    name="WorkPhone"
   
    value={ContactDetailForm.WorkPhone}
    placeholder="Please Enter*"
    onChange={handleChange}
    required
  />
  </tr>
  </div>
  <div className="col-lg-6 col-md-6 col-sm-6">
  <tr><td>First Name</td>
  <input
    type="text"
    name="FirstName"
   
    value={ContactDetailForm.FirstName}
    placeholder="Please Enter*"
            onChange={handleChange}  
            required
  />
  </tr>
  <tr>   
  <td>Email Address</td>
  <input
    type="email"
    name="Email"
   
    value={ContactDetailForm.Email}
    placeholder="Please Enter*"
    onChange={handleChange}
    required
  />
  </tr>
  
  <tr>   
  <td >Mobile</td>
  <input
    type="text"
    name="Mobile"
   
    value={ContactDetailForm.Mobile}
    placeholder="Please Enter*"
    onChange={handleChange}
    required
  />
  </tr>
  </div>
  
  </tbody>
  </table>
  
    <br />
    <hr />
    <div style={{marginBottom:"38px",display:"flex"}}  className={`reset-addSupplier-button ${userType === "admin" ? "admin_type_contact_buttons_main_div" : ""}`}>
  {edit?
   <button
     type="submit"
     onClick={handleSubmit}
     style={{
       backgroundColor: "#5B489D",
       color: "white",
     }}
   >
     Update
   </button>
  :
  <button
  type="submit"
  onClick={handleSubmit}
  style={{
    backgroundColor: "#5B489D",
    color: "white",
  }}
  >
  Next
  </button>
  }
  
  <button
  onClick={cancelEdit}
   style={{
     color: "red",
     backgroundColor:"white",
     border:"none"

   }}
  >
   Cancel
  </button> 
  
  
    </div>
  </div>
  <div className="container-fluid">
            <div className="contact_details_list_main-div">
            <table className={` ${userType !== "admin" ? "vendor_type_contact_detail_list":""}`} >
              
          <thead>
            <tr className="supplierListHeading">
            <th >S.No.</th>
              <th >Salutation</th>
              <th >First Name</th>
              <th >Last Name</th>
              <th >Email Address</th>
              <th >Work Phone</th>
              <th >Mobile</th>
              {formSubmitted?
              null:
              <th>Action</th>
              }
  
            </tr>     
          </thead>
          <tbody>
            {filledData!== null ? (
             filledData.map((data, index) => (
                <tr key={index}>
                  <td >{data.ContactID}</td>
                  <td >{data.Salutation}</td>
                  <td >{data.FirstName}</td>
                  <td >{data.LastName}</td>
                  <td >{data.Email}</td>
                  <td >{data.WorkPhone}</td>
                  <td >{data.Mobile}</td>
                  {formSubmitted?
                  null:
                  <td style={{cursor:"pointer"}} onClick={()=>updateCurrentVendorContactDetail(data)}>Edit</td>
                  }
                </tr>
              ))
            ) : (
              <tr>
              </tr>
            )}
          </tbody>
        </table>
                                <h4 style={{fontSize:"17px",color:"blue",marginTop:"31px",cursor:"pointer"}} onClick={AddMoreAccounts}>+ Add More Contacts</h4>
            </div>
            </div>
            </div>
            :
            <div className="container-fluid">
            <div className="contact_details_list_main-div">
            <table className={` ${userType !== "admin" ? "vendor_type_contact_detail_list":""}`} >
              
          <thead>
            <tr className="supplierListHeading">
            <th >S.No.</th>
              <th >Salutation</th>
              <th >First Name</th>
              <th >Last Name</th>
              <th >Email Address</th>
              <th >Work Phone</th>
              <th >Mobile</th>
              {formSubmitted?
              null:
              <th>Action</th>
              }
  
            </tr>     
          </thead>
          <tbody>
            {filledData!== null ? (
             filledData.map((data, index) => (
                <tr key={index}>
                  <td >{data.ContactID}</td>
                  <td >{data.Salutation}</td>
                  <td >{data.FirstName}</td>
                  <td >{data.LastName}</td>
                  <td >{data.Email}</td>
                  <td >{data.WorkPhone}</td>
                  <td >{data.Mobile}</td>
                  {formSubmitted?
                  null
                :
                  <td style={{cursor:"pointer"}} onClick={()=>updateCurrentVendorContactDetail(data)}>Edit</td>
                }
                </tr>
              ))
            ) : (
              <tr>
              </tr>
            )}
          </tbody>
        </table>
        {formSubmitted?
                  null
                :
                                <h4 style={{fontSize:"17px",color:"blue",marginTop:"31px",cursor:"pointer"}} onClick={AddMoreAccounts}>+ Add More Contacts</h4>
        }
                                </div>
            </div>
            }
     
       
    
           
        
          
    </div>
    </div>
      )

}

export default AddVendorContactDetails